module.exports = __webpack_public_path__ + "static/media/bdsp-marathon-bg.a8124e46.png";